/**
 * Build a word as an SVG of glyph outlines — one filled <path> per letter — so it
 * can be ETCHED (DrawSVG draw-on over the contours, ink bloom at the golden cut)
 * in the Glass-Etch idiom. DOM text can't be DrawSVG-etched; glyph paths can. The
 * etchable-word surfaces — the game-start "Lothar" wordmark, the Play label, the
 * mode-card names, and the in-play opponent name strips — share this one
 * construction; they differ only in their glyph data, their SVG class, and their
 * accessible label, all parameters here.
 *
 * `glyphData` is a `{ viewBox, glyphs: [{ d }] }` bag of author-extracted
 * Satoshi-Bold (700) outlines in font units (unitsPerEm=1000), y-flipped into SVG
 * space (baseline at y=0). `inkColor` is a concrete color, not a CSS var — the etch
 * sets SVG stroke attrs and tweens `fill`, neither of which resolves a var, so the
 * caller resolves it first. role+aria-label keep the word readable now that it is
 * graphics, not text. overflow:visible (via the class) so the etch's round-capped
 * stroke isn't clipped at the viewBox edge.
 */
const SVG_NS = "http://www.w3.org/2000/svg";

export function buildGlyphWordSvg(
  glyphData,
  inkColor,
  { className, ariaLabel },
) {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", glyphData.viewBox);
  svg.setAttribute("role", "img");
  svg.setAttribute("aria-label", ariaLabel);
  svg.classList.add(className);
  for (const { d } of glyphData.glyphs) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    path.setAttribute("fill", inkColor);
    svg.appendChild(path);
  }
  return svg;
}
